const mainServices = [
  {
    title: "Life Insurance",
    icon: (
      <img
        src="assets/img/life-inc.png"
        style={{ height: "4em" }}
        alt="Life Insurance"
      />
    ),
  },
  {
    title: "Health Insurance",
    icon: (
      <img
        src="assets/img/cross.png"
        style={{ height: "4em" }}
        alt="Life Insurance"
      />
    ),
  },
];

export default mainServices;
